import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const location = useLocation();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-foreground-950 no-underline hover:no-underline mb-4"
            >
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-capsule-line text-lg text-background-50"></i>
              </div>
              <span className="text-lg font-semibold" style={{ fontFamily: "var(--font-heading)" }}>
                牛奶片库
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              牛奶片库 — 精选牛奶片大全，品质甄选一站购齐。我们致力于为消费者提供最专业、最全面的牛奶片产品信息与选购指南。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline hover:no-underline">
                首页
              </Link>
              <Link to="/category/children" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline hover:no-underline">
                产品分类
              </Link>
              <Link to="/article/milk-tablet-buying-guide-complete" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline hover:no-underline">
                选购指南
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline hover:no-underline">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">产品分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors no-underline hover:no-underline"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm text-foreground-600">
                <i className="ri-mail-line mr-2"></i>
                hello@naipianku.com
              </p>
              <p className="text-sm text-foreground-600">
                <i className="ri-phone-line mr-2"></i>
                400-888-9999
              </p>
              <p className="text-sm text-foreground-600">
                <i className="ri-map-pin-line mr-2"></i>
                上海市浦东新区张江高科技园区
              </p>
              <div className="flex items-center gap-3 mt-2">
                <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2025 牛奶片库 naipianku.com 版权所有 | 沪ICP备2025000001号
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors no-underline hover:no-underline">
              隐私政策
            </Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors no-underline hover:no-underline">
              用户协议
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}